import { Reducer } from 'redux'

import { ReportsState, ReportsActionTypes } from './types'

const INITIAL_STATE: ReportsState = {
  error: null,
  loading: null,
  reportsList: [],
  reportsResources: {
    R1Data: {
      data: [],
      error: false,
      loading: false
    },
    R1Header: {
      data: [],
      error: false,
      loading: false
    },
    R2Data: {
      data: [],
      error: false,
      loading: false
    },
    R2Header: {
      data: [],
      error: false,
      loading: false
    },
    R3Data: {
      data: [],
      error: false,
      loading: false
    },
    R3Header: {
      data: [],
      error: false,
      loading: false
    },
    R4Data: {
      data: [],
      error: false,
      loading: false
    },
    R4Header: {
      data: [],
      error: false,
      loading: false
    },
    R5Data: {
      data: [],
      error: false,
      loading: false
    },
    R5Header: {
      data: [],
      error: false,
      loading: false
    },
    R6Data: {
      data: [],
      error: false,
      loading: false
    },
    R6Header: {
      data: [],
      error: false,
      loading: false
    },
    R7Data: {
      data: [],
      error: false,
      loading: false
    },
    R7Header: {
      data: [],
      error: false,
      loading: false
    },
    R8Data: {
      data: [],
      error: false,
      loading: false
    },
    R8Header: {
      data: [],
      error: false,
      loading: false
    },
    R9Data: {
      data: [],
      error: false,
      loading: false
    },
    R9Header: {
      data: [],
      error: false,
      loading: false
    },
    R10Data: {
      data: [],
      error: false,
      loading: false
    },
    R11Data: {
      data: [],
      error: false,
      loading: false
    },
    R11Header: {
      data: [],
      error: false,
      loading: false
    },
    R12Data: {
      data: [],
      error: false,
      loading: false
    },
    R12Header: {
      data: [],
      error: false,
      loading: false
    },
    R13Data: {
      data: [],
      error: false,
      loading: false
    },
    R13Header: {
      data: [],
      error: false,
      loading: false
    },
    R14Data: {
      data: [],
      error: false,
      loading: false
    },
    R14Header: {
      data: [],
      error: false,
      loading: false
    },
    R15Data: {
      data: [],
      error: false,
      loading: false
    },
    R15Header: {
      data: [],
      error: false,
      loading: false
    }
  }
}

const reducer: Reducer<ReportsState> = (
  state = INITIAL_STATE,
  { payload, type }
) => {
  switch (type) {
    /**
     * GET_REPORTS
     */
    case ReportsActionTypes.GET_REPORTS:
      return {
        ...state,
        error: false,
        loading: true,
        reportsList: [],
        reportsResources: {
          ...INITIAL_STATE.reportsResources
        }
      }
    case ReportsActionTypes.GET_REPORTS_SUCCESS:
      return {
        ...state,
        loading: false,
        reportsList: [...payload.reports]
      }
    case ReportsActionTypes.GET_REPORTS_FAILURE:
      return {
        ...state,
        error: true,
        loading: false
      }

    /**
     * GET_REPORTS_RESOURCE
     */
    case ReportsActionTypes.GET_REPORTS_RESOURCE:
      return {
        ...state,
        reportsResources: {
          ...state.reportsResources,
          [payload.resource]: {
            // @ts-ignore
            ...state.reportsResources[payload.resource],
            error: false,
            loading: true
          }
        }
      }
    case ReportsActionTypes.GET_REPORTS_RESOURCE_SUCCESS:
      return {
        ...state,
        reportsResources: {
          ...state.reportsResources,
          [payload.resource]: {
            // @ts-ignore
            ...state.reportsResources[payload.resource],
            loading: false,
            data: payload.data
          }
        }
      }
    case ReportsActionTypes.GET_REPORTS_RESOURCE_FAILURE:
      return {
        ...state,
        reportsResources: {
          ...state.reportsResources,
          [payload.resource]: {
            data: [],
            error: true,
            loading: false
          }
        }
      }
    case ReportsActionTypes.RESOURCE_RESET:
      return {
        ...state,
        reportsResources: INITIAL_STATE.reportsResources
      }
    /**
     * DEFAULT
     */
    default:
      return state
  }
}

export default reducer
